import React, { Component } from 'react';

export default class PropertyGridItem extends Component {

    state = {

    };

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
        this.registerPropertyValueChangedEvent(this.props.source);
    }

    componentWillReceiveProps(nextProps) {
        this.unregisterPropertyValueChangedEvent();
        this.registerPropertyValueChangedEvent(nextProps.source);
    }

    componentWillUnmount() {
        this.unregisterPropertyValueChangedEvent();
    }

    registerPropertyValueChangedEvent(property) {
        this.unregisterPropertyChangedListener = property.registerPropertyChangedListener((name, valOld, valNew, subName) => {
            // console.log(`onPropertyValueChanged from PropertyItem: ${property.name}, ${name}`);
            this.onPropertyValueChanged(property.name, valOld, valNew, name);
        });
    }

    unregisterPropertyValueChangedEvent() {
        if (this.unregisterPropertyChangedListener)
            this.unregisterPropertyChangedListener();
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        if (subName === "visible")
            this.setState({});
    }

    render() {

        return (
            <div style={{ display: (this.props.source.visible === false ? 'none' : "block") }}>
                {this.props.children}
            </div>
        );
    }
}
